/**
 * @module components\header
 */
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import store from '@/store';
import i18nService from '@/services/i18n';
import { getLanguageCode, getLanguage } from '../../utilities/helperFunctions';
import Logout from '@/services/api/logout';

@Component
export default class Header extends Vue {
  lang = 'en';
  changeLanguage(lang: string) {
    i18nService.setLanguage(lang);
  }
  defaultLang = getLanguage(this.$store.state.lang);
  selectedOption = this.defaultLang;
  get disabled() {
    return !(
      this.$route &&
      this.$route.name &&
      this.$route.name === 'SelfcareRaiseComplaint'
    );
  }
  menu = [
    {
      icon: 'mdi-phone',
      // title: '180030008329, 0120-3986786',
      // link: 'tel:180030008329, 0120-3986786',
      title: '0120-3645645',
      link: 'tel:0120-3645645',
    },
    {
      icon: 'mdi-email',
      title: 'customercare@spicemoney.com',
      link: 'mailto:customercare@spicemoney.com',
    },
  ];
  language = [
    'English',
    'Hindi',
    'Asamiya',
    'Bangla',
    'Gujarati',
    'Kannada',
    'Tamil',
    'Malayalam',
    'Marathi',
    'Odiya',
    'Punjabi',
    'Telugu',
  ];
  //Add these if Asked { icon: "null1", title: "Help Video", link: "need-help" }, { icon: "null", title: "Offer", link: "Offer" }

  @Watch('selectedOption')
  langFilter(val: any) {
    let langCode = getLanguageCode(val);
    this.selectedOption = val;
    store.commit('setAppLang', langCode);
  }

  navigateToMain() {
    this.$router.push({ name: 'SelfcareRaiseComplaint' });
  }

  async logout() {
    try {
      const r = await Logout.expireSession();
      if (r.data.responseStatus === 'S' || r.data.responseCode === 'SAEX') {
        window.open('', '_self').close();
      }
    } catch (e) {}
  }
}
